// Курсор в поле ввода — на своём месте после сдвига экрана (27.10.2026).
//
// 🪤 РАЗБОР. Владелец: «в Долгах при вводе суммы курсор смещается ниже строки
// ввода», и похожее — в добавлении в календаре. Окно формы стоит над
// клавиатурой. Переход с поля имени на поле суммы меняет клавиатуру на
// цифровую, у неё другая высота, и окно сдвигается. iPhone (и окно Телеграма
// на нём) при этом оставляет мигающий курсор там, где поле БЫЛО, — ниже
// строки. Сам текст пишется верно, врёт только отрисовка курсора.
//
// Лечение одно на всё приложение: после любого сдвига видимой части экрана
// заново ставим выделение в поле в фокусе — это заставляет движок нарисовать
// курсор заново, на текущем месте. Правимый текст заметок (contenteditable)
// не трогаем: у редактора своё выделение, вмешательство его ломает.

function поле(): HTMLInputElement | HTMLTextAreaElement | null {
    const а = document.activeElement;
    if (а instanceof HTMLTextAreaElement) return а;
    if (а instanceof HTMLInputElement && /^(text|search|tel|url|email|password|number|)$/.test(а.type)) return а;
    return null;
}

function перерисовать(): void {
    const п = поле();
    if (!п) return;
    try {
        const начало = п.selectionStart;
        const конец = п.selectionEnd;
        if (начало === null || конец === null) return;
        п.setSelectionRange(начало, конец);
    } catch {
        // поле с типом, где выделение недоступно (number на части движков)
    }
}

let таймер = 0;
function послеСдвига(): void {
    window.clearTimeout(таймер);
    requestAnimationFrame(перерисовать);
    // Окно доезжает плавно — ещё раз, когда всё встало.
    таймер = window.setTimeout(перерисовать, 180);
}

export function installCaretRepaint(): void {
    const вв = window.visualViewport;
    вв?.addEventListener('resize', послеСдвига);
    вв?.addEventListener('scroll', послеСдвига);
    window.addEventListener('resize', послеСдвига);
    // Фокус перешёл в другое поле — клавиатура может смениться.
    document.addEventListener('focusin', () => window.setTimeout(послеСдвига, 60));
    // --kb-h (Capacitor) меняется в стиле корня — окно сдвигается.
    new MutationObserver(послеСдвига).observe(document.documentElement, {
        attributes: true, attributeFilter: ['style'],
    });
}
